import { combineReducers } from 'redux'

import list from './list/slice'

const savedReducer = combineReducers({
  list,
})

export default savedReducer
